<template>
  <v-container :class="'mt-0 pt-0 '" fluid>
    <v-card class="pa-0 ma-0 mt-7 mb-5" elevation="0">
      <v-row style="align-items: center">
        <v-col class="my-0 py-0" cols="2">
          <SelectFilter
            class="mb-0 pb-0"
            :label="this.$t('cards.banks')"
            :get-request="this.$axios.banks"
            item-text="bankName"
            item-value="bankId"
            :selectedItem="bankFilterArray"
            :disabled="2"
            :prepend-icon="'mdi-bank'"
            notMultiple
            v-on:changed="onChangeBankFilter"
            v-on:items="(items) => (banks = items)"
          />
        </v-col>

        <v-col class="my-0 py-0" cols="2">
          <SelectFilter
            :label="this.$t('cards.branches')"
            filtered
            :items-root="branches"
            notMultiple
            item-text="name"
            :disabled="this.$store.getters.CAN_SEE_BRANCHES ? 0 : 2"
            item-value="branchId"
            :selectedItem="branchFilterArray"
            :prepend-icon="'mdi-source-branch'"
            no-data-text="No branches!"
            v-on:changed="(items) => (branchFilterArray = items)"
          />
        </v-col>

        <v-col class="my-0 py-0" cols="2">
          <v-text-field
            :value="usernameFilter"
            @change="(v) => (usernameFilter = v)"
            clearable
            :label="$t('referenceBooks.users.UserName')"
            :prepend-icon="'mdi-account'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <ComboboxFilter
            filtered
            :label="this.$t('referenceBooks.users.UserType')"
            :items-root="translatedUserTypes"
            item-text="translatedName"
            item-value="typeId"
            :prepend-icon="'mdi-account'"
            v-on:changed="(items) => (this.userTypeFilterArray = items)"
          />
        </v-col>
        <v-spacer></v-spacer>
        <SearchButtons
          v-on:clear="clearFilters"
          v-on:get="getKiosks"
        />   
      </v-row>
    </v-card>
    <v-card>
      <v-card-title class="mt-3">
        <div>{{ $t("referenceBooks.users.Users") }}</div>
        <v-divider class="mx-4" inset vertical></v-divider>
        <UserDialog
          @created="onCreated"
          :mode="0"
          :bank="bankParam"
          :branch="branchParam"
          :key="userDialogKey-1"
          @rerender="rerenderUserDialog"
        />
        <UserDialog
          v-if="isActive"
          @updated="onUpdated"
          :mode="1"
          :key="userDialogKey+1"
          :userId="selected[0]"
          @rerender="rerenderUserDialog"
        />
        <ConfigUserRolesAndRightsDialogAnotherVersion
          v-if="isActive"
          :user="selected[0]"
          @changed="onChanged"
          @rerender="rerenderConfigRolesDialog"
          :key="configRolesDialogKey"
        />
        <Confirm
          v-if="isActive"
          :textLable="$t('confirm.inactionTime') + ' (' + $t('minutes') + ')'"
          :title="logoutTimePromtTitle"
          @ok="(text) => onChangeLogoutTime(text)"
          :icon-name="'mdi-clock-time-eight-outline'"
          :tooltipText="$t('confirm.inactionTime')"
          :hasTextField="true"
          :okText="'Save'"
          :cancelText="'Cancel'"
          :errRegexText="$t('confirm.mustBeDigits')"
          :textFieldPattern="'^[1-9]\\d*$'"
        />
        <PinUserToAnotherBranch
          v-if="isActive"
          :user="selected[0]"
          @attach="onAttached"
          :key="pinUserToAnotherBranchDialogKey"
        />
        <Confirm
          v-if="canLock && isActive"
          :text="$t('referenceBooks.users.Lock')"
          :title="
            $t('referenceBooks.users.Lock') + ' ' + selected[0].name + ' ' + '?'
          "
          v-on:ok="onLockUser"
          :icon-name="'mdi-pin'"
          :tooltipText="$t('referenceBooks.users.Lock')"
          :key="lockUnlockKey"
        />
        <Confirm
          v-if="canUnlock && isActive"
          :text="$t('referenceBooks.users.Unlock')"
          :title="
            $t('referenceBooks.users.Unlock') +
              ' ' +
              selected[0].name +
              ' ' +
              '?'
          "
          v-on:ok="onUnlockUser"
          :icon-name="'mdi-pin-off'"
          :tooltipText="$t('referenceBooks.users.Unlock')"
          :key="lockUnlockKey"
        />
        <Confirm
          v-if="isActive"
          :text="$t('referenceBooks.users.Delete')"
          :title="
            $t('referenceBooks.users.Delete') +
              ' ' +
              selected[0].name +
              ' ' +
              '?'
          "
          v-on:ok="onDeleteUser"
          :icon-name="'mdi-close'"
          :tooltipText="$t('referenceBooks.users.Delete')"
        />
        <Confirm
          v-if="isNotActive"
          :title="restoreConfirmTitle"
          :tooltipText="$t('confirm.restoreUser')"
          v-on:ok="onRestore"
          iconName="mdi-restore"
        />
      </v-card-title>
      <LoadIcon v-if="loading" />
      <LightTable
        :headers="headers"
        :items="users"
        :loading="loading"
        itemKey="userId"
        defaultSortColumn="name"
        :selectedItems="selected"
        :markedItems="changedUsersId"
        v-on:update="onUpdate"
        singleSelect
        v-on:changedSortDesc="onChangeSortDesc"
        v-on:changedSort="onChangeSort"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        v-on:onChangeLogoutTime="onInactionTimeButton"
        :height="tableHeight"
      />
    </v-card>
    <v-row align="start" class="mt-3">
      <v-col class="d-flex">
        <v-row  style="display: flex; justify-content: center">
          <v-pagination
            v-model="page"
            :length="paginationLength"
            :total-visible="totalVisible"
          />
        </v-row>
      </v-col>
      <p class="d-flex v-card__title">
        {{ $t("cards.records") }} {{ $t("from") }} {{ limit * (page - 1) + 1 }}
        {{ $t("to") }} {{ limit * page }}
      </p>
      <p align="right" class="d-flex v-card__title">
        {{ $t("cards.total") }}: {{ totalCount }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
import { notifySuccess, notifyError } from '@/services/notifications';
import UserDialog from '@/components/UserDialog';
import ComboboxFilter from '@/components/FiltersComponent/ComboboxFilter';
import LoadIcon from '@/components/LoadIcon';
import Confirm from '@/components/Confirm';
import PinUserToAnotherBranch from '@/components/PinUserToAnotherBranch';
import LightTable from '@/components/Tables/LightTable';
import SelectFilter from '@/components/FiltersComponent/SelectFilter';
import SearchButtons from '@/components/FiltersComponent/SearchButtons';
import tableHeightMixin from './mixins/tableHeightMixin';
import ConfigUserRolesAndRightsDialogAnotherVersion from '@/components/ConfigUserRolesAndRightsDialogAnotherVersion';
import valIsNull from '@/services/valIsNull';

export default {
  name: 'Users',
  mixins: [tableHeightMixin],
  components: {
    ConfigUserRolesAndRightsDialogAnotherVersion,
    LightTable,
    PinUserToAnotherBranch,
    UserDialog,
    ComboboxFilter,
    LoadIcon,
    Confirm,
    SelectFilter,
    SearchButtons,
  },
  data() {
    return {
      loading: false,
      changedUsersId: [],
      pinUserToAnotherBranchDialogKey: 222,
      configRolesDialogKey: 0,

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 64,
      filterH: 44,
      tHeaderH: 70,
      tFooterH: 96,

      selectedRoles: [],
      selectedBranch: null,

      userDialogKey: 999,
      inactiveTimeDialog: false,

      searchBranches: null,
      searchRoles: null,
      allBranches: [],
      allRoles: [],

      dialog: false,
      selected: [],
      users: [],
      usersTmp: [],

      page: 1,
      limit: 10,
      limitValues: [{ value: 5 }, { value: 10 }, { value: 25 }, { value: 50 }],
      paginationLength: 100,
      totalCount: '',
      totalVisible: 10,

      banks: [],
      branches: [],
      userTypes: [],
      branchFilterArray: [],
      bankFilterArray: [],
      usernameFilter: '',
      userTypeFilterArray: [],

      lockUnlockKey: 0,
      sortBy: [],
      sortDesc: [],
    };
  },
  created() {
    this.$eventBus.$on('langChanged', this.onChangeLang);
  },
  beforeDestroy() {
    this.$eventBus.$off('langChanged');
  },
  computed: {
    restoreConfirmTitle() {
      return this.$t('confirm.restoreUser') + ' ' + this.selected[0].name + '?';
    },
    logoutTimePromtTitle() {
      return this.$t('confirm.changeInactionTime') + ' ' + this.selected[0].name;
    },
    isActive() {
      return this.selected.length === 1 && this.selected[0].typeId !== 4;
    },
    isNotActive() {
      return this.selected.length === 1 && this.selected[0].typeId === 4;
    },
    translatedUserTypes() {
      return this.userTypes.map((ut) => {
        return {
          ...ut,
          translatedName: this.$t('userTypesNames.userType' + ut.typeId),
        };
      });
    },
    bankParam() {
      return this.bankFilterArray == null || this.bankFilterArray.length == 0
        ? null
        : this.bankFilterArray;
    },
    branchParam() {
      return this.branchFilterArray == null ||
        this.branchFilterArray.length == 0
        ? null
        : this.branchFilterArray;
    },
    headers() {
      let result = [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.users.BankName'),
          value: 'bankName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.users.UserName'),
          value: 'name',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.users.BranchName'),
          value: 'branchName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.users.Description'),
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.users.Roles'),
          value: 'roles',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.users.UserType'),
          value: 'typeId',
          sortable: true,
        },
        { text: '', value: 'userActions', sortable: false },
      ];

      if (this.$store.getters.RIGHTS_ON_BANK_LEVEL)
        result = result.filter((h) => h.value !== 'bankName');
      if (this.$store.getters.RIGHTS_ON_BRANCH_LEVEL)
        result = result.filter((h) => h.value !== 'branchName');

      return result;
    },
    filterJson() {
      const result = {};
      result.branchesId =
        this.branchFilterArray.branchId !== undefined
          ? [this.branchFilterArray.branchId]
          : [];
      result.banksId =
        this.bankFilterArray.bankId !== undefined
          ? [this.bankFilterArray.bankId]
          : [];
      result.typesId = this.userTypeFilterArray.map((ut) => ut.typeId);
      result.username = !this.usernameFilter ? '' : this.usernameFilter;

      return result;
    },
    canDelete() {
      return this.selected.length === 1;
    },
    canUnlock() {
      return this.selected.length === 1 && this.selected[0].typeId === 3;
    },
    canLock() {
      return this.selected.length === 1 && this.selected[0].typeId !== 3;
    },
  },
  watch: {
    filterJson() {
      this.getUsers();
    },
    bankFilterArray: async function() {
      this.branches = [];
      const banksId = [this.bankFilterArray.bankId];

      await this.$axios.branches
        .getByBanksArrayForUsersPage(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.branches = Array.isArray(json) ? json : [];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selected: function() {
      this.userDialogKey++;
      this.configRolesDialogKey++;
    },
    page: async function() {
      await this.getUsers();
    },
    limit: async function() {
      if (this.page === 1) await this.getUsers();
      else this.page = 1;
    },
  },
  async mounted() {
    this.getUserTypes();
  },
  methods: {
    onInactionTimeButton(text, val) {
      this.changeLogoutTime(text, val);
    },
    onChangeSort(sort) {
      this.sortBy = sort;

      if (this.sortDesc.length === this.sortBy.length)
        this.users = this.sortData(
          this.usersTmp,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    onChangeSortDesc(sortDesc) {
      this.sortDesc = sortDesc;

      if (this.sortDesc.length === this.sortBy.length)
        this.users = this.sortData(
          this.usersTmp,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    sortData(items, sortBy, desc) {
      items.sort(function(a, b) {
        let index = 0;

        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (valIsNull(a[sortBy[index]]) && valIsNull(b[sortBy[index]]))
            return 0;
          if (valIsNull(a[sortBy[index]])) return isDesc ? -1 : 1;
          if (valIsNull(b[sortBy[index]])) return isDesc ? 1 : -1;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    onChangeLang() {
      this.userTypeFilterArray = this.userTypeFilterArray.map((ut) => {
        return {
          ...ut,
          translatedName: this.$t('userTypesNames.userType' + ut.typeId),
        };
      });
    },
    addDefaultUserTypes() {
      // Default filter for only "regular/new" users was disabled.
      // this.userTypeFilterArray = this.translatedUserTypes.filter(
      //   (item) => item.typeId == 1 || item.typeId == 2
      // );
      this.userTypeFilterArray = [];
    },
    setUsertTypes(val) {
      this.userTypes = val;
      this.addDefaultUserTypes();
    },
    async getUserTypes() {
      await this.$axios.userTypes
        .get()
        .then((response) => response.data)
        .then((json) => this.setUsertTypes(json))
        .catch((error) => {
          console.error(error);
          notifyError('', this.$t('Error'));
        });
    },
    rerenderUserDialog() {
      this.userDialogKey++;
    },
    rerenderConfigRolesDialog() {
      this.configRolesDialogKey++;
    },
    clearFilters() {
      if (this.banks.length > 1) {
        this.bankFilterArray = [];
        this.branchFilterArray = [];
      } else if (this.banks.length === 1 && this.branches.length > 1) {
        this.branchFilterArray = [];
      }
      this.usernameFilter = '';
      this.addDefaultUserTypes();

      this.getUsers();
    },
    onChangeBankFilter(items) {
      this.bankFilterArray = items;
    },
    onUpdate(items) {
      this.selected = items;
      this.changedUsersId = [];
    },
    markRow(userId) {
      this.changedUsersId = [];
      this.changedUsersId.push(userId);
    },
    onAttached(userId) {
      this.pinUserToAnotherBranchDialogKey++;
      this.selected = [];
      this.getUsers();
      this.markRow(userId);
    },
    onChanged(userId) {
      this.configRolesDialogKey++;
      this.selected = [];
      this.getUsers();
      this.markRow(userId);
    },
    async onCreated(userId) {
      this.userDialogKey++;
      this.selected = [];
      this.getUsers();
      this.markRow(userId);
    },
    async onUpdated(userId) {
      this.userDialogKey++;
      this.selected = [];
      this.getUsers();
      this.markRow(userId);
    },
    async onLockUser() {
      const user = this.selected[0];
      await this.$axios.users
        .lock(user.userId)
        .then(() => {
          notifySuccess('', this.$t('Messages.UserWasLocked', [user.name]));
          this.selected = [];
          this.getUsers();
          this.markRow(user.userId);
        })
        .catch((error) => {
          console.error(error);
          notifyError('', this.$t('Error'));
        });
    },
    async onUnlockUser() {
      const user = this.selected[0];
      await this.$axios.users
        .unlock(user.userId)
        .then(() => {
          notifySuccess('', this.$t('Messages.UserWasUnlocked', [user.name]));
          this.selected = [];
          this.getUsers();
          this.markRow(user.userId);
        })
        .catch((error) => {
          console.error(error);
          notifyError('', this.$t('Error'));
        });

      const selectedTemp = this.selected;
      this.selected = [];
      this.selected = selectedTemp;
    },
    async onDeleteUser() {
      const user = this.selected[0];
      await this.$axios.users
        .deleteById(user.userId)
        .then(() => {
          notifySuccess('', this.$t('Messages.UserWasDeleted', [user.name]));
          this.getUsers();
          this.selected = [];
        })
        .catch((error) => {
          console.error(error);
          notifyError('', this.$t('referenceBooks.users.RemoveError'));
        });
    },
    async onRestore() {
      const val = this.selected[0];
      await this.$axios.users
        .restore(val.userId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess('', this.$t('Messages.UserWasRestored', [val.name]));
          } else
            this.showMessage(
              this.$t('Restored'),
              `${this.$t('referenceBooks.users.Name')}: ${val.name}\n${this.$t(
                'Status'
              )}: ${response.status}`,
              'warn'
            );
          this.getUsers();
        })
        .catch((error) => {
          console.error(error);
          notifyError(this.$t('errorsMessages.Restore'), error);
        });
    },
    onChangeLogoutTime(value) {
      this.changeLogoutTime(value, this.selected[0]);
    },
    changeLogoutTime(value, user) {
      user.timeout = parseInt(value, 10);

      this.$axios.users
        .putByIdTimeout(user.userId, user)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.UserInactionTimeChanged', [user.name])
          );
        })
        .catch((error) => {
          console.error(error);
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileEditingUser', [user.name])
          );
        });
    },
    async getUsers() {
      const params = {
        limit: this.limit,
        offset: this.limit * (this.page - 1),
        query: JSON.stringify(this.filterJson),
      };
      await this.$axios.users
        .get(params)
        .then((response) => response.data)
        .then((json) => {
          this.usersTmp = this.sortData(json.users, this.sortBy, this.sortDesc);
          this.users = this.usersTmp;
        })
        .catch((e) => {
          console.error(e);
        });

      await this.$axios.users
        .getCount(params)
        .then((response) => response.data)
        .then((json) => {
          this.totalCount = json.totalCount;
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
        });
    },
  },
};
</script>
